import { applyToAllStates } from '../../../theme/utils/button.theme.utils';
var secondaryTextStyles = {
  small: 'body4',
  medium: 'body3',
  large: 'body2'
};
export var nakedButtonTheme = {
  baseStyle: {
    p: 'none',
    m: 'none',
    textDecoration: 'underline',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    outline: '2px solid transparent',
    borderRadius: 'm',
    _disabled: {
      cursor: 'not-allowed'
    }
  },
  sizes: {
    small: {
      textStyle: 'body4Semi'
    },
    medium: {
      textStyle: 'body3Semi'
    },
    large: {
      textStyle: 'body2Semi'
    }
  },
  variants: {
    primary: _ref => {
      var {
        theme
      } = _ref;
      return {
        color: 'neutral.black',
        _hover: {
          color: 'brand.main'
        },
        _active: {
          color: 'brand.dark'
        },
        _disabled: applyToAllStates({
          color: 'neutral.light'
        }),
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: theme.space['xxs'],
          transition: 'outline-color 0.2s'
        }
      };
    },
    secondary: _ref2 => {
      var {
        size,
        theme
      } = _ref2;
      return {
        color: 'nakedButton.secondary.default.color',
        textStyle: size && secondaryTextStyles[size],
        _hover: {
          color: 'nakedButton.secondary.hover.color'
        },
        _active: {
          color: 'nakedButton.secondary.active.color'
        },
        _disabled: applyToAllStates({
          color: 'neutral.light'
        }),
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: theme.space['xxs'],
          transition: 'outline-color 0.2s'
        }
      };
    },
    invert: _ref3 => {
      var {
        theme
      } = _ref3;
      return {
        color: 'neutral.white',
        _hover: {
          opacity: 0.8
        },
        _active: {
          opacity: 0.6
        },
        _disabled: applyToAllStates({
          opacity: 0.35
        }),
        _focusVisible: {
          outlineColor: 'focus.invert',
          outlineOffset: theme.space['xxs'],
          transition: 'outline-color 0.2s'
        }
      };
    },
    critical: _ref4 => {
      var {
        theme
      } = _ref4;
      return {
        color: 'critical.main',
        _hover: {
          color: 'critical.dark'
        },
        _active: {
          color: 'critical.darkest'
        },
        _disabled: applyToAllStates({
          color: 'neutral.light'
        }),
        _focusVisible: {
          outlineColor: 'focus.focus',
          outlineOffset: theme.space['xxs'],
          transition: 'outline-color 0.2s'
        }
      };
    }
  },
  defaultProps: {
    variant: 'primary',
    size: 'medium'
  }
};
//# sourceMappingURL=NakedButton.theme.js.map